import React, { useState } from 'react';
import { ShopContext } from './ShopContext';

export const ShopProvider = ({ children }) => {

    // CartItemId State
    const [toggleMenu, setToggleMenu] = useState(false);

    const [startMatch, setStartMatch] = useState(localStorage.getItem('startMatch'));

    const [striker, setStriker] = useState(null);
    const [nonStriker, setNonStriker] = useState(null);
    const [currentBowler, setCurrentBowler] = useState(null);

    const [isDisabled, setIsDisabled] = useState(false);

    return (
        <ShopContext.Provider
            value={{
                toggleMenu,
                setToggleMenu,
                startMatch, setStartMatch,
                striker, setStriker,
                nonStriker, setNonStriker,
                currentBowler, setCurrentBowler,
                isDisabled, setIsDisabled
            }}
        >
            {children}
        </ShopContext.Provider>
    );
};
